import { ConstructorFilterKeys, DominantEnum, UploadConstructorValueType } from '../schema';

export const dominantValue: Record<DominantEnum, string> = {
  HOUSE: 'Turar joy majmuasi',
  CONTRACT: 'Shartnoma',
  CLIENT: 'Mijoz',
  BOOKING: 'Buyurtma',
  DEBT: 'Qarzdorlik',
  PAYMENT: "To'lovlar"
};

export const constructorFilterValues: Record<ConstructorFilterKeys, UploadConstructorValueType> = {
  // CONTRACT
  contractCreatedDateFilter: {
    required: true,
    key: 'range-picker',
    label: 'Shartnoma sanasi',
    formKey: ['contractCreatedDateStart', 'contractCreatedDateFinish'],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.DEBT, DominantEnum.PAYMENT]
  },
  contractCurrencyFilter: {
    options: [],
    key: 'select',
    formKey: 'contractCurrency',
    label: 'Shartnoma valyutasi',
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.DEBT]
  },
  contractPrepaymentDateFilter: {
    key: 'range-picker',
    label: "Shartnoma boshlang'ich to'lov sanasi",
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT],
    formKey: ['contractPrepaymentDateStart', 'contractPrepaymentDateFinish']
  },
  contractFormalityFilter: {
    key: 'select',
    label: 'Shartnoma rasmiyligi',
    formKey: 'isFormal',
    options: [
      {
        value: true,
        label: 'Tasdiqlangan'
      },
      {
        value: false,
        label: 'Tasdiqlanmagan'
      }
    ],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT]
  },
  contractResponsibleByFilter: {
    key: 'select',
    multiple: true,
    label: "Shartnoma mas'ul shaxsi",
    formKey: 'contractResponsible',
    options: [],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.DEBT]
  },
  contractStatusFilter: {
    key: 'select',
    multiple: true,
    label: 'Shartnoma holati',
    formKey: 'contractStatus',
    options: [
      {
        value: 'STARTED',
        label: "Boshlang'ich"
      },
      {
        value: 'ACTIVE',
        label: 'Faol'
      },
      {
        value: 'CANCELLED',
        label: 'Bekor qilingan'
      },
      {
        value: 'FINISHED',
        label: 'Tugallangan'
      },
      {
        value: 'TRANSFERRED',
        label: "O'tkazilgan"
      }
    ],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT]
  },

  // BOOKING
  bookingStatusFilter: {
    key: 'select',
    multiple: true,
    label: 'Buyurtma holati',
    formKey: 'bookingStatus',
    options: [
      {
        label: 'Shartnoma qilingan',
        value: 'CONTRACT'
      },
      {
        label: 'Faol',
        value: 'ACTIVE'
      },
      {
        label: 'Bekor qilingan',
        value: 'CANCELED'
      }
    ],
    dominants: [DominantEnum.HOUSE, DominantEnum.BOOKING]
  },
  bookingCreatedDateFilter: {
    required: true,
    key: 'range-picker',
    label: 'Buyurtma sanasi',
    formKey: ['bookingCreatedDateStart', 'bookingCreatedDateFinish'],
    dominants: [DominantEnum.HOUSE, DominantEnum.BOOKING, DominantEnum.PAYMENT]
  },

  // CLIENT
  clientCountryFilter: {
    key: 'select',
    label: 'Mamlakat',
    formKey: 'clientCountry',
    childFormKey: 'clientCity',
    options: [],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING, DominantEnum.CLIENT]
  },
  clientCityFilter: {
    key: 'select',
    formKey: 'clientCity',
    label: 'Viloyat (Shahar)',
    requiredFormKey: 'clientCountry',
    options: [],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING, DominantEnum.CLIENT]
  },
  clientDistrictFilter: {
    key: 'select',
    label: 'Tuman',
    formKey: 'clientDistrict',
    requiredFormKey: 'clientCity',
    options: [],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING, DominantEnum.CLIENT]
  },
  clientResponsibleByFilter: {
    key: 'select',
    multiple: true,
    label: "Mas'ul shaxs",
    formKey: 'clientResponsibleByFilter',
    options: [],
    dominants: [DominantEnum.CLIENT]
  },
  clientDateFilter: {
    label: 'Sana',
    required: true,
    key: 'range-picker',
    dominants: [DominantEnum.CLIENT],
    formKey: ['clientDateStart', 'clientDateFinish']
  },
  clientStatusFilter: {
    key: 'select',
    multiple: true,
    label: 'Mijoz holati',
    formKey: 'clientStatuses',
    options: [
      {
        value: 'Yangi',
        label: 'NEW'
      },
      {
        value: 'ACTIVE',
        label: 'Faol'
      },
      {
        value: 'PASSIVE',
        label: 'Faol emas'
      }
    ],
    dominants: [DominantEnum.CLIENT]
  },

  // HOUSES
  housesFilter: {
    key: 'select',
    multiple: true,
    formKey: 'houses',
    childFormKey: 'buildings',
    label: 'Turar-joy majmuasi',
    options: [],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.DEBT, DominantEnum.BOOKING]
  },
  buildingsFilter: {
    key: 'select',
    multiple: true,
    label: 'Binolar',
    formKey: 'buildings',
    requiredFormKey: 'houses',
    options: [],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING, DominantEnum.DEBT]
  },
  flatRepairedFilter: {
    key: 'select',
    label: "Ta'mirlilik holati",
    formKey: 'flatRepaired',
    options: [
      {
        value: null,
        label: 'Barchasi'
      },
      {
        value: true,
        label: "Ta'mirli"
      },
      {
        value: false,
        label: "Ta'mirsiz"
      }
    ],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING]
  },
  flatStatusFilter: {
    key: 'select',
    multiple: true,
    label: 'Xonadon holati',
    formKey: 'flatStatus',
    options: [
      {
        value: 'SALE',
        label: "Bo'sh"
      },
      {
        value: 'BOOKED',
        label: 'Band qilingan'
      },
      {
        value: 'SOLD',
        label: 'Sotilgan'
      }
    ],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING]
  },
  flatApartmentTypeFilter: {
    key: 'select',
    multiple: true,
    label: 'Xonadon turi',
    formKey: 'flatApartmentType',
    options: [
      {
        value: 'BASEMENT',
        label: "Yerto'la"
      },
      {
        value: 'SHOP',
        label: "Do'kon"
      },
      {
        value: 'PARKING',
        label: 'Avtoturargoh'
      },
      {
        value: 'APARTMENT',
        label: 'Xonadon'
      }
    ],
    dominants: [DominantEnum.HOUSE, DominantEnum.CONTRACT, DominantEnum.BOOKING]
  },

  // PAYMENT
  paymentCreatedDateFilter: {
    required: true,
    key: 'range-picker',
    label: "To'lov sanasi",
    dominants: [DominantEnum.PAYMENT],
    formKey: ['paymentCreatedDateStart', 'paymentCreatedDateFinish']
  },
  paymentResponsibleByFilter: {
    key: 'select',
    multiple: true,
    label: "To'lovga mas'ul shaxs",
    formKey: 'paymentResponsible',
    options: [],
    dominants: [DominantEnum.PAYMENT]
  },
  paymentTypeFilter: {
    key: 'select',
    multiple: true,
    label: "To'lov turi",
    formKey: 'paymentTypes',
    options: [
      {
        value: 'CARD',
        label: 'Terminal'
      },
      {
        value: 'CASH',
        label: 'Naqd'
      },
      {
        value: 'TRANSFER',
        label: 'P2P'
      },
      {
        value: 'BALANCE',
        label: 'Balansdan'
      },
      {
        value: 'BANK',
        label: 'Bank'
      },
      {
        value: 'PAYME',
        label: 'Payme'
      },
      {
        value: 'MY_UZCARD',
        label: 'MyUzcard'
      },
      {
        value: 'UZUM',
        label: 'Uzum'
      },
      {
        value: 'PAYLOV',
        label: ''
      },
      {
        value: 'UYSOT_PAY',
        label: 'Uysot Pay'
      },
      {
        value: 'OTHERS',
        label: 'Boshqa'
      },
      {
        value: 'CUSTOM',
        label: 'Odatiy'
      }
    ],
    dominants: [DominantEnum.PAYMENT]
  },
  paymentBaseFilter: {
    key: 'select',
    multiple: true,
    label: "To'lov maqsadi",
    formKey: 'paymentBase',
    options: [
      {
        value: 'CONTRACT',
        label: 'Shartnoma'
      },
      {
        value: 'SURCHARGE',
        label: 'Peniya'
      },
      {
        value: 'CLIENT',
        label: 'Balans'
      },
      {
        value: 'BOOKING',
        label: 'Buyurtma'
      }
    ],
    dominants: [DominantEnum.PAYMENT]
  },
  paymentActiveFilter: {
    key: 'select',
    label: "To'lov aktivligi",
    formKey: 'isActive',
    options: [
      {
        value: null,
        label: 'Barchasi'
      },
      {
        value: true,
        label: 'Faol'
      },
      {
        value: false,
        label: 'Bekor qilingan'
      }
    ],
    dominants: [DominantEnum.DEBT, DominantEnum.PAYMENT]
  },

  // DEBT
  dateFilter: {
    key: 'date',
    formKey: 'date',
    label: 'Sana',
    dominants: [DominantEnum.DEBT]
  }
};

export const dominants = ['HOUSE', 'CONTRACT', 'CLIENT', 'BOOKING', 'DEBT', 'PAYMENT'];

export * from './query-keys';
